module.exports = __webpack_public_path__ + "static/media/toplu-mms.1b983804.png";